import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../LoadingSpinner';

interface ProtectedRouteProps {
	children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const { isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return <LoadingSpinner variant='fullscreen' message='Provera pristupa...' size='large' />;
	}

	if (!isAuthenticated) {
		return <Navigate to='/admin/login' replace />;
	}

	return <>{children}</>;
};
